import { render, staticRenderFns } from "./WatchStatistics.vue?vue&type=template&id=a2be5c60&"
import script from "./WatchStatistics.vue?vue&type=script&lang=js&"
export * from "./WatchStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports